import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_1, COLOR_SURFACE_2 } from '../../colors';

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class AreaChart extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data, ranking } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.XYChart);
    chart.data = data;

    // -- category axis (X)
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'period';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 20;
    categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.labels.template.hideOversized = false;
    categoryAxis.renderer.labels.template.fill = am4core.color(COLOR_FONT_1);
    categoryAxis.startLocation = 0.5;
    categoryAxis.endLocation = 0.5;

    // -- value axis (Y)
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.calculateTotals = true;
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.labels.template.fill = am4core.color(COLOR_FONT_1);
    valueAxis.renderer.labels.template.adapter.add('text', (text) => `${text}%`);

    // -- hyrdate Other series
    const otherSeries = chart.series.push(new am4charts.LineSeries());
    otherSeries.dataFields.valueY = 'Other';
    otherSeries.dataFields.valueYShow = 'totalPercent';
    otherSeries.dataFields.categoryX = 'period';
    otherSeries.name = 'Other';

    otherSeries.tooltipHTML = 'Other {valueY.value}';

    otherSeries.tooltip.getFillFromObject = false;
    otherSeries.tooltip.background.fill = am4core.color(COLOR_SURFACE_2);

    otherSeries.tooltip.getStrokeFromObject = true;
    otherSeries.tooltip.background.strokeWidth = 3;

    otherSeries.fillOpacity = 0.85;
    otherSeries.stacked = true;

    // -- hyrdate entity serieses
    for (const item of ranking) {
      const series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = item.name_display;
      series.dataFields.valueYShow = 'totalPercent';
      series.dataFields.categoryX = 'period';
      series.name = item.name_display;

      series.tooltipHTML = `${item.name_display} {valueY.value}`;

      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color(COLOR_SURFACE_2);

      series.tooltip.getStrokeFromObject = true;
      series.tooltip.background.strokeWidth = 3;

      series.fillOpacity = 0.85;
      series.stacked = true;
    }

    // -- cursor
    chart.cursor = new am4charts.XYCursor();

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: '512px' }} />;
  }
}
